import notification from 'notification-js';
import Config from 'config';
import Modal from '../node_modules/modal-js/dist/modal';
import Validator from 'validator';
import * as Validation from './Validation';

export default class EditProfile {
  constructor(options) {
    this.onSubmit = options.onsubmit;

    let html = `<div class="edit-profile-modal">
      <form method="post">
        <div class="form-group">
            <label for="currentPassword">Current Password</label>
            <input type="password" class="form-control currentPassword" id="currentPassword" placeholder="Current Password">
        </div>
        <div class="form-group">
            <label for="newPassword">New Password</label>
            <input type="password" class="form-control newPassword" id="newPassword" placeholder="New Password">
        </div>
        <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <input type="password" class="form-control confirmPassword" id="confirmPassword" placeholder="Confirm Password">
        </div>
        <div class="form-group">
          <input type="submit" name="submit" class='updateButton' value="Update" />
          <input type="button" name="cancel" class='cancelSubmitButton' value="Cancel" />
        </div>
      </form>
    </div>`;

    this.modal = new Modal({
      el: html,
      containerEl: document.getElementById('modals-container'),
      activeClass: 'modal-active',
      onShow: () => {},
      onHide: () => {},
      onClickOutside: (modal) => {
      }
    });
    this.modal.hide();

    this.currentPassword = this.modal.el.getElementsByClassName('currentPassword')[0];
    this.newPassword = this.modal.el.getElementsByClassName('newPassword')[0];
    this.confirmPassword = this.modal.el.getElementsByClassName('confirmPassword')[0];
    this.cancelSubmitButton = this.modal.el.getElementsByClassName('cancelSubmitButton')[0];
    this.updateSubmitButton = this.modal.el.getElementsByClassName('updateButton')[0];

    this.cancelSubmitButton.onclick = function(event) {
      this.modal.hide();
    }.bind(this)

    this.updateSubmitButton.onclick = function(event) {
      event.preventDefault();
      var userData = {};

      if (this.validateForm()) {
        var passwordData = {
          currentPassword: this.currentPassword.value,
          newPassword: this.newPassword.value
        };

        this.onSubmit(passwordData);
      }

    }.bind(this)
  }

  showEditPassword(data) {
    var body = document.body,
        html = document.documentElement;

    var height = Math.max( body.scrollHeight, body.offsetHeight,
                           html.clientHeight, html.scrollHeight, html.offsetHeight );

    this.modal.el.parentNode.style.height = height + 'px';

    this.modal.show();
  }

  hideEditPassword() {
    this.modal.hide();
  }

  validateForm() {
    if (!this.currentPassword.value) {
      notification.notify( 'error', 'Please enter your current password', {
        notification: {position: [ 'right', 'top' ]}
      });
      return false;
    }

    if (this.newPassword.value !== this.confirmPassword.value) {
      notification.notify( 'error', 'The confirm password does not match', {
        notification: {position: [ 'right', 'top' ]}
      });
      return false;
    }

    if (Validation.validatePassword(this.newPassword.value)) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/EditPassword.js